
const QuoteIcon = () => {
  return (
    <svg viewBox="0 0 72 58" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M54.7651 0C52.4027 0 50.1745 0.456482 48.0805 1.36945C45.9866 2.28241 44.1611 3.51759 42.604 5.075C41.047 6.63241 39.8121 8.45833 38.8993 10.5528C37.9866 12.6472 37.5302 14.8759 37.5302 17.2389C37.5302 21.1056 38.604 24.4352 40.7517 27.2278C42.8993 30.0204 45.3154 31.9537 48 33.0278L36.0805 58L49.9329 58L68.6174 28.3556C70.8725 24.8111 72 21.1056 72 17.2389C72 14.8759 71.5436 12.6472 70.6309 10.5528C69.7181 8.45833 68.4832 6.63241 66.9262 5.075C65.3691 3.51759 63.5436 2.28241 61.4497 1.36945C59.3557 0.456482 57.1275 0 54.7651 0Z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M18.685 0C16.3226 0 14.0944 0.456482 12.0005 1.36945C9.9065 2.28241 8.081 3.51759 6.52395 5.075C4.9669 6.63241 3.732 8.45833 2.81925 10.5528C1.9065 12.6472 1.45012 14.8759 1.45012 17.2389C1.45012 21.1056 2.52395 24.4352 4.6716 27.2278C6.81925 30.0204 9.23536 31.9537 11.9199 33.0278L0.000457764 58L13.8528 58L32.5374 28.3556C34.7924 24.8111 35.9199 21.1056 35.9199 17.2389C35.9199 14.8759 35.4635 12.6472 34.5508 10.5528C33.638 8.45833 32.4031 6.63241 30.8461 5.075C29.289 3.51759 27.4635 2.28241 25.3696 1.36945C23.2756 0.456482 21.0474 0 18.685 0Z"
        fill="url(#paint1_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="72.3369"
          y1="-2.00237"
          x2="36.0805"
          y2="-2.00237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#990099" />
          <stop offset="1" stop-color="#FF0000" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="36.2569"
          y1="-2.00237"
          x2="0.000457494"
          y2="-2.00237"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#990099" />
          <stop offset="1" stop-color="#FF0000" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default QuoteIcon;
